import { useTranslation } from 'react-i18next'

import { useNetworkGateaway, WS_STATUS } from '@/providers/NetworkGateway.provider'

import { Callout } from '../Typography/Callout'

const backgroundColor = new Map<string, string>([
  [WS_STATUS.CLOSED, 'bg-error-red'],
  [WS_STATUS.CONNECTING, 'bg-news-pastel'],
  [WS_STATUS.CONNECTED, 'bg-positive-accent'],
])

export const NetworkBadge = () => {
  const { websocketStatus, showWebsocketStatus } = useNetworkGateaway()
  const { t } = useTranslation()

  if (!showWebsocketStatus) return null

  const classNames = `w-[17px] h-[17px] rounded-full ${backgroundColor.get(websocketStatus)}`

  return (
    <div className="fixed bottom-4 right-4 rounded-full p-2 flex items-center gap-x-2 bg-black-140 text-offwhite-150">
      <div className={classNames} />
      <Callout className="text-current" variant="callout3">
        {t(`${websocketStatus}NetworkBadge`)}
      </Callout>
    </div>
  )
}
